
export const DetailsRechargesConstants = [
    {
        id: 'number',
        label: 'Número de teléfono',
        value: null
    },
    {
        id: 'account',
        label: 'Cuenta origen',
        value: null
    },
    {
        id: 'nextPayment',
        label: 'Próximo pago',
        value: null
    }
];